import { Box, Breakpoint, Dialog, Typography, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import React from "react";
import CustomSvgIcon from "./Icons/CustomSvgIcon";
import PermissionRestrictedComponent from "./PermissionRestrictedComponent";
import { createPortal } from "react-dom";
import CustomLoader from "./CustomLoader";

interface PopupViewProps {
  open: boolean;
  onClose?: () => void; // Made optional
  title: string;
  children: React.ReactNode;
  icon?: any;
  bgColor?: string;
  createModifyPermission: number | null;
  width?: Breakpoint;
  maxHeight?: string | number;
  showClose?: boolean;
  loading?: boolean;
}

const PopupView: React.FC<PopupViewProps> = ({
  open,
  onClose,
  title,
  children,
  icon,
  bgColor = (theme: any) => theme.palette.primary.main,
  createModifyPermission,
  showClose = false,
  width = "md",
  maxHeight = "80vh",
  loading = false,
}) => {
  return createPortal(
    <PermissionRestrictedComponent permission={createModifyPermission}>
      <Dialog
        open={open}
        onClose={onClose}
        fullWidth
        maxWidth={width}
        sx={{
          "& .MuiPaper-root": {
            borderRadius: "24px",
            p: 0,
            overflow: "hidden",
          },
        }}
      >
        {!loading ? (
          <>
            {/* Fixed Header */}
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                backgroundColor: bgColor,
                color: "white",
                padding: 3,
                position: "sticky",
                top: 0,
                zIndex: 1,
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                <Typography variant="h5">{title}</Typography>
                <CustomSvgIcon src={icon} />
              </Box>

              {showClose && (
                <IconButton
                  onClick={onClose}
                  sx={{
                    color: "white",
                    marginLeft: 2, // Add some spacing between title/icon and close button
                    "&:hover": {
                      backgroundColor: "rgba(255, 255, 255, 0.1)",
                    },
                  }}
                >
                  <CloseIcon />
                </IconButton>
              )}
            </Box>

            {/* Scrollable Content */}
            <Box
              sx={{
                overflowY: "auto",
                maxHeight: maxHeight,
                p: 4,
              }}
            >
              {children}
            </Box>
          </>
        ) : (
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            p={4}
            sx={{ backgroundColor: "white", borderRadius: 2 }}
          >
            <CustomLoader size={30} />
          </Box>
        )}
      </Dialog>
    </PermissionRestrictedComponent>,
    document.body
  );
};

export default PopupView;
